import { createEffect, createRoot } from 'solid-js'
import { createStore } from 'solid-js/store'

import { USER_INFO } from 'shared'

import { Session, UserInfo, api_user_get } from 'api'

type SelfModel = {
    token: string | null
    user: UserInfo
    loged_in: boolean
    fetch: boolean
    session: Session | null
    loading: boolean
}

async function fetch_self() {
    setSelf({ loading: true })
    let res = await api_user_get({ show_alert: false })
    setSelf({ loading: false, fetch: false })

    if (res.err()) {
        setSelf({ loged_in: false, user: USER_INFO, token: '' })
        return
    }

    let user_info = res.body
    let session = user_info.sessions[user_info.session_index]!

    setSelf({
        token: session.token,
        user: user_info,
        session: session,
        loged_in: true,
        fetch: false,
    })
}

const [self, setSelf] = createStore<SelfModel>({
    fetch: true,
    loged_in: false,
    session: null,
    token: null,
    loading: true,
    user: USER_INFO,
})
export { self }

createRoot(() => {
    createEffect(() => {
        if (self.fetch) {
            fetch_self()
            return
        }
    })
})
